import React from 'react';
import { Outlet } from 'react-router-dom';
import { useProSidebar } from 'react-pro-sidebar';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import IconButton from '@mui/material/IconButton';
import CustomSideBar from '../sidebar/SideBar';

const SidebarLayout = () => {
  const { toggleSidebar, broken } = useProSidebar();

  return (
    <div className="flex min-h-screen">
      <CustomSideBar />
      <div className="w-full overflow-y-scroll overflow-x-hidden">
        {broken && (
          <div className="sticky top-0 m-0 w-full bg-white shadow-2xl">
            <IconButton onClick={toggleSidebar}>
              <MenuRoundedIcon />
            </IconButton>
          </div>
        )}
        <Outlet />
      </div>
    </div>
  );
};

export default SidebarLayout;
